'use strict';

import React, { Component } from 'react';
import DialogMui from '../../../commonModules/interface/Dialog';

var $ = require('jquery');

class ValidationOverlay extends Component{

    state = {
        // popupState: this.props.popupStateButton, 
        msg: this.props.msg,
        errormsg:""
    }

    // componentWillReceiveProps = async (nextProps) => {
    //     // You don't have to do this check first, but it can help prevent an unneeded render
    //     if (nextProps.popupStateButton !== this.state.popupState) {
    //         this.setState({popupState: nextProps.popupStateButton});
    //     }
    // }
    // cancel = async (e) => {
    //     e.preventDefault();
    //     console.log("Cancel Validation");
    //     this.setState({popupState: false,errormsg:""});
    //     this.props.onCancelation();
    // }
    valid =  (e) => {
        e.preventDefault();
        console.log("[INFO], ValidationOverlay,  Validation");

        var urlValidation = this.props.url

        this.serverRequest = $.get(urlValidation, function(result) {
            console.log('[INFO],  reception front of Validation: ');
            console.log(result);
            if (result.error === 'OK') {
                // this.setState({popupState: false});
                this.props.onValidation();
            } else {
                this.setState({
                    errormsg: 'Error : ' + result.error.content
                });
            }
        }.bind(this));
    }
    componentWillUnmount() {
        try {
            this.serverRequest.abort();
        } catch (e) {
            console.log(e);
        }
    }
    render() {
        console.log("[DEBUG], ValidationOverlay, Button Proceed ",this.state.errormsg);
        return (
            <DialogMui
                close={this.props.onCancelation}
                submitAction={this.valid}
                block={true}
            >
                <p>{this.props.msg}</p>
                <p>{this.state.errormsg}</p>
                {/* <div className="text-right">
                    <button className="btn btn-cancel" onClick={this.cancel}>Cancel</button>
                    <button className="btn btn-primary" onClick={this.valid}>Ok</button>
                </div> */}
            </DialogMui>
        );
    }
};
export default ValidationOverlay
